import React, { useState } from 'react';
import { 
  Container, Paper, TextField, Button, Typography, 
  Box, Alert, CircularProgress, InputAdornment 
} from '@mui/material';
import { Email, ArrowBack } from '@mui/icons-material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', msg: '' });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', msg: '' });

    try {
      // Adjusted to match your urls.py path
      await axios.post('http://localhost:8000/api/auth/password-reset-request/', { email });
      setStatus({ 
        type: 'success', 
        msg: 'If an account exists with this email, a reset link has been sent.' 
      });
    } catch (err) {
      setStatus({ 
        type: 'error', 
        msg: 'Something went wrong. Please try again later.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      minHeight: '80vh', display: 'flex', alignItems: 'center', 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e8f5e9 100%)' 
    }}>
      <Container maxWidth="xs">
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: '1px solid #e0e0e0', textAlign: 'center' }}>
          <Typography variant="h5" fontWeight="700" gutterBottom color="#36454F">
            Reset Password
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Enter your email address and we'll send you a link to reset your password.
          </Typography>

          {status.msg && <Alert severity={status.type} sx={{ mb: 3, borderRadius: 2 }}>{status.msg}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email Address"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              disabled={loading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: '#2E7D32' }} />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 3 }}
            />
            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading}
              sx={{ 
                py: 1.5, fontWeight: 700, borderRadius: 2,
                background: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%)'
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Send Reset Link'}
            </Button>
          </form>

          <Button
            startIcon={<ArrowBack />}
            component={RouterLink}
            to="/login"
            sx={{ mt: 3, color: '#666', textTransform: 'none' }}
          >
            Back to Login
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;